import { createGlobalState } from "react-use";
import { useCallback } from "react";

const useGlobalUIState = createGlobalState({
  trackId: 0,
  swiper: null,
});

const useUIState = () => {
  const [state, setState] = useGlobalUIState();

  const mergeState = useCallback(
    (state) => {
      setState((prevState) => Object.assign({}, prevState, state));
    },
    [setState]
  );

  const setTrackId = useCallback(
    (value) => mergeState({ trackId: value }),
    [mergeState]
  );

  const setSwiper = useCallback(
    (value) => mergeState({ swiper: value }),
    [mergeState]
  );

  return {
    state,
    setTrackId,
    setSwiper,
  };
};

export default useUIState;
